import { after } from './bits'
import { isNull } from 'lodash-es'

import StrictObj from './strict-obj'
import debugFields from './debug-fields'

let id = 0
const nextId = () => id++

export default function Ticker(delay) {
  let intervalId = null
  const regs = []
  const ticker = StrictObj(debugFields({
    id: nextId(),
    off: after(off, afterOff),
    clear: after(clear, afterOff),
    oneTick: after(oneTick, afterOn),
    eachTick: after(eachTick, afterOn)
  }, {
    _regs: regs,
    _delay: delay,
    _intervalId: () => intervalId
  }))

  return ticker

  function iterateRegs() {
    const local = regs.concat()
    for (let index = 0, length = local.length; index !== length; index++) {
      const reg = local[index]
      reg.count++
      if ((reg.count % reg.tick) === 0) {
        reg.handler.call(reg.context, reg.count)
        reg.fired = true
      }
    }

    for (let index = regs.length - 1; index !== -1; index--) {
      const reg = regs[index]
      if (reg.once && reg.fired) {
        regs.splice(index, 1)
      }
    }
  }

  function afterOff() {
    if (!isNull(intervalId) && regs.length === 0) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  function afterOn() {
    if (isNull(intervalId)) {
      intervalId = setInterval(iterateRegs, delay)
    }
  }

  function off(handler, context) {
    for (let index = 0, length = regs.length; index !== length; index++) {
      const reg = regs[index]
      const equal = reg.handler === handler && reg.context === context
      if (equal) {
        regs.splice(index, 1)
        break
      }
    }
  }

  function clear() {
    regs.length = 0
  }

  function oneTick(tick, handler, context) {
    regs.push({
      once: true,
      fired: false,
      tick,
      count: 0,
      handler,
      context
    })
  }

  function eachTick(tick, handler, context) {
    regs.push({
      once: false,
      fired: false,
      tick,
      count: 0,
      handler,
      context
    })
  }
}
